import React, { useState, forwardRef } from 'react';
import Sheet from '@mui/joy/Sheet';
import Stack from '@mui/joy/Stack';
import Box from '@mui/joy/Box';
import { styled } from '@mui/joy/styles';
import Typography from '@mui/joy/Typography';



/////////////////////// Modal
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';



//////////////////// Mune DropDown
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import MoreVert from '@mui/icons-material/MoreVert';
import Edit from '@mui/icons-material/Edit';
import DeleteForever from '@mui/icons-material/DeleteForever';
import MenuButton from '@mui/joy/MenuButton';
import Dropdown from '@mui/joy/Dropdown';


import HideIcon from '../../assets/icons/hideIcon.svg'
import TrashIcon from '../../assets/icons/trashIcon.svg'
import EditIcon from '../../assets/icons/edit.svg'



////////////////////// API
import { deleteQuestions } from '../../Api/FAQ'


const Item = styled(Sheet)(({ theme }) => ({
    ...theme.typography['body-sm'],
    textAlign: 'center',
    fontWeight: theme.fontWeight.md,
    color: theme.vars.palette.text.secondary,
    border: '1px solid',
    borderColor: '#E9E9E9',
    padding: '24px',
    borderRadius: theme.radius.md,
    boxShadow: '2px 2px 0px rgba(0, 0, 0, 0.08)'
}))

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});



export default function FAQComponent(props) {
    const { listQuestions, getListQuestions, actionEdit } = props
    const [openModal, setOpenModal] = useState(false);
    const [questionId, setQuestionId] = useState(0);
    const [statusActionFqa, setStatusActionFqa] = useState(null)

    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const confirmRemoveQuestions = async (id) => {
        setQuestionId(id)
        setOpenModal(true)
    }

    const removeQuestions = async () => {
        const res = await deleteQuestions(questionId);
        if (res) {
            setOpenModal(false)
            getListQuestions();
            setOpenAlert(true)
            setMessageAlert("تم الحذف بنجاح")
        }
    }


    return (
        <>

            {/* Alert Meesage */}
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>


            {/* Modal PopUp */}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <ModalDialog
                    aria-labelledby="nested-modal-title"
                    aria-describedby="nested-modal-description"
                    sx={(theme) => ({
                        [theme.breakpoints.only('xs')]: {
                            top: 'unset',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            borderRadius: 0,
                            transform: 'none',
                            maxWidth: 'unset',
                        },
                        direction: 'rtl'
                    })}
                >
                    <Typography id="nested-modal-title" level="h2">
                        هل انت متاكد من حذف السؤال ؟
                    </Typography>
                    <Typography id="nested-modal-description" textColor="text.tertiary">
                        لا يمكن التراجع عن هذا الإجراء. سيؤدي هذا إلى حذف سؤال بشكل دائم وإزالة بياناتك من خوادمنا.
                    </Typography>
                    <Box
                        sx={{
                            mt: 1,
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row-reverse' },
                        }}
                    >
                        <Button variant="solid" color="primary" onClick={() => removeQuestions()}>
                            تأكيد
                        </Button>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setOpenModal(false)}
                        >
                            الغاء
                        </Button>
                    </Box>
                </ModalDialog>
            </Modal>


            <Box sx={{ width: '100%', marginTop: '50px', padding: '0 2%', boxSizing: 'border-box' }}>
                <Stack spacing={2}>
                    {listQuestions.map((faqItem) => {
                        return (
                            <Item sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Sheet sx={{ width: '90%', textAlign: 'start' }}>
                                    <Typography level="h2" sx={{ mb: 2, fontSize: '18px', color: '#434448' }}>
                                        {faqItem.title}
                                    </Typography>
                                    <Typography level="p" sx={{ fontSize: '14px', color: '#434448' }}>
                                        {faqItem.answer}
                                    </Typography>
                                </Sheet>
                                <Sheet sx={{ width: '5%' }}>
                                    <Dropdown>
                                        <MenuButton
                                            slots={{ root: IconButton }}
                                            slotProps={{ root: { variant: 'plan', color: 'neutral' } }}

                                        >
                                            <MoreVert />
                                        </MenuButton>
                                        <Menu placement="bottom-end">
                                            <MenuItem sx={{ color: '#434448' }} onClick={() => confirmRemoveQuestions(faqItem.id)}>
                                                <ListItemDecorator sx={{ color: 'inherit' }}>
                                                    <img src={TrashIcon} alt='icon' />
                                                </ListItemDecorator>{' '}
                                                حذف السؤال
                                            </MenuItem>
                                            <MenuItem sx={{ color: '#434448' }} onClick={() => actionEdit(faqItem.id, 'edit')}>
                                                <ListItemDecorator>
                                                    <img src={EditIcon} alt='icon' />
                                                </ListItemDecorator>{' '}
                                                تعديل السؤال
                                            </MenuItem>

                                        </Menu>
                                    </Dropdown>
                                </Sheet>
                            </Item>
                        )
                    })}
                </Stack>
            </Box>
        </>
    );
}
